import { render, staticRenderFns } from "./Insurance_bSales.vue?vue&type=template&id=52c20f60&scoped=true"
import script from "./Insurance_bSales.vue?vue&type=script&lang=js"
export * from "./Insurance_bSales.vue?vue&type=script&lang=js"
import style0 from "./Insurance_bSales.vue?vue&type=style&index=0&id=52c20f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c20f60",
  null
  
)

export default component.exports